<template>
  <div class="profile-dropdown flex-center">
    <span class="profile-dropdown__avatar-container">
      <slot />
    </span>
    <vuestic-dropdown v-model="isShown"
                      position="bottom">
      <a v-for="option in options"
         :key="option.name"
         class="dropdown-item plain-link-item"
         @click="show(option.name)">
        <span class="dropdown-item__text ellipsis">{{
          $t(`user.${option.name}`)
        }}</span>
      </a>
    </vuestic-dropdown>
  </div>
</template>

<script>
import { request } from "@/utils/utils";
export default {
  name: "profile-section",
  props: {
    options: {
      type: Array,
      default: () => [
        {
          name: "profile",
          redirectTo: "",
        },
        {
          name: "logout",
          redirectTo: "login",
        },
      ],
    },
  },
  data() {
    return {
      isShown: false,
    };
  },
  methods: {
    show(data) {
      if (data === "profile") {
        this.$router.push({
          name: "Profile",
        });
        return;
      }
      if (data === "logout") {
        // TODO 调用logout接口、并删除缓存token、重定位到login页面
        let token = localStorage.getItem("Authorization");
        if (!token) {
          localStorage.clear();
          this.$router.push({
            name: "login",
          });
          return;
        }
        request({
          method: "delete",
          url: `api/dashboard/logout?access_token=${token}`,
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
          .then((res) => {
            let fg = res.data;
            if (fg === true) {
            } else {
              this.$message({
                duration: 1200,
                message: this.$t("logout.tips2"),
                type: "success",
              });
            }
            localStorage.removeItem("Authorization");
            localStorage.clear();
            this.$router.push({
              name: "login",
            });
          })
          .catch((err) => {
            localStorage.clear();
            this.$router.push({
              name: "login",
            });
          });
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../../../vuestic-theme/vuestic-sass/resources/resources";

.profile-dropdown {
  cursor: pointer;

  &__avatar-container {
    display: inline-block;
    width: 50px;
    height: 50px;
    background-color: white;
    border-radius: 50%;
    border: 2px solid $lighter-gray;
    overflow: hidden;

    img {
      height: 100%;
      width: 100%;
    }
  }
}
// .dropdown-item {
//   height: $navbar-dd-item-height;
//   cursor: pointer;
//   font-size: $font-size-base;

//   &:hover, &:active, &:focus, &.active {
//     outline: none;
//   }

//   &.plain-link-item {
//     line-height: 40px;
//     color: white!important;
//     background: $dropdown-background;

//     &:hover, &:active, &:focus {
//       color: $dropdown-background!important;
//       background: white;
//     }

//     .plain-link {
//       text-decoration: none;
//     }
//   }
// }
</style>
